import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

import { DietService } from 'src/app/services/diet.service';
import { ToastService } from 'src/app/services/toast.service';

import { Diet, Meal } from 'src/app/interfaces/diet';

@Component({
  selector: 'app-meal-form-modal',
  templateUrl: './meal-form-modal.component.html',
  styleUrls: ['./meal-form-modal.component.scss'],
})
export class MealFormModalComponent implements OnInit, OnChanges {
  @ViewChild('mealFormModal') mealModal: ElementRef | undefined;

  @Input() editing: boolean | undefined;
  @Input() meal: Meal | undefined;
  @Input() diet: Diet | undefined;

  @Output() mealCreated = new EventEmitter<Meal>();

  mealForm: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private toastService: ToastService,
    private dietService: DietService
  ) {
    this.mealForm = this.fb.group({
      title: ['', [Validators.required]],
      description: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    if (this.editing) {
      this.title.setValue(this.meal!.title);
      this.description.setValue(this.meal!.description);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['editing']) {
      if (this.editing) {
        this.title.setValue(this.meal!.title);
        this.description.setValue(this.meal!.description);
      } else {
        this.title.reset();
        this.description.reset();
      }
    }
  }

  onSubmit() {
    this.editing ? this.updateMeal() : this.createMeal();
  }

  createMeal() {
    let mealOrder: number;

    if (this.diet!.meals) {
      const lastMealIndex = this.diet!.meals.length - 1;
      mealOrder = this.diet!.meals[lastMealIndex].order + 1;
    } else {
      mealOrder = 1;
    }

    const meal: Pick<Meal, 'dietId' | 'title' | 'description' | 'order'> = {
      title: this.title.value,
      description: this.description.value,
      dietId: this.diet!.id,
      order: mealOrder,
    };

    this.dietService.createMeal(meal).subscribe({
      next: (meal: Meal) => {
        this.mealCreated.emit(meal);
        this.clearForm();
        this.toastService.success('Se creó la comida con éxito.');
      },
      error: (_error) => {
        this.toastService.alert(
          'Ha ocurrido un error creando la comida. Si el error persiste contactarse con el soporte.'
        );
      },
    });
  }

  updateMeal() {
    this.meal!.description = this.description.value;
    this.meal!.title = this.title.value;

    this.dietService.updateMeal(this.meal!).subscribe({
      next: (response: any) => {
        this.clearForm();
        this.toastService.success('Se creó la comida con éxito.');
      },
      error: (_error) => {
        this.toastService.alert(
          'Ha ocurrido un error creando la comida. Si el error persiste contactarse con el soporte.'
        );
      },
    });
  }

  clearForm() {
    this.title.setValue('');
    this.description.setValue('');
    this.mealForm.reset();
  }

  get title() {
    return this.mealForm.controls['title'];
  }

  get description() {
    return this.mealForm.controls['description'];
  }
}
